"use strict";
/** *******************************************************************************************************************
  Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
  
  Licensed under the Apache License, Version 2.0 (the "License").
  You may not use this file except in compliance with the License.
  You may obtain a copy of the License at
  
      http://www.apache.org/licenses/LICENSE-2.0
  
  Unless required by applicable law or agreed to in writing, software
  distributed under the License is distributed on an "AS IS" BASIS,
  WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  See the License for the specific language governing permissions and
  limitations under the License.                                                                              *
 ******************************************************************************************************************** */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const icons_1 = require("@material-ui/icons");
function TableHead({ headerGroups, styles }) {
    return (react_1.default.createElement(core_1.TableHead, null, headerGroups.map((headerGroup) => (react_1.default.createElement(core_1.TableRow, Object.assign({}, headerGroup.getHeaderGroupProps(), { className: styles.tableHeadRow }), headerGroup.headers.map((column) => {
        var _a, _b;
        return column.id !== '_all_' && (react_1.default.createElement(core_1.TableCell, Object.assign({}, column.getHeaderProps()),
            react_1.default.createElement("div", null,
                column.canSort ? (react_1.default.createElement(core_1.TableSortLabel, Object.assign({}, column.getSortByToggleProps(), { active: column.isSorted, direction: column.isSortedDesc ? 'desc' : 'asc', IconComponent: icons_1.ArrowDropDown, className: styles.cellAlign }),
                    react_1.default.createElement("span", null, (_a = column.render) === null || _a === void 0 ? void 0 : _a.call(column, 'Header')))) : (react_1.default.createElement("span", null, (_b = column.render) === null || _b === void 0 ? void 0 : _b.call(column, 'Header'))),
                react_1.default.createElement("div", Object.assign({}, column.getResizerProps(), { className: styles.resizer })))));
    }))))));
}
exports.default = TableHead;
//# sourceMappingURL=index.js.map